import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import DATA from "../const/data";

const Page = styled.article`
    width: min(100%, 720px);
    margin: 0 auto;

    .back-link {
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        color: var(--text-soft);
        font-size: 14px;
        font-weight: 650;
    }

    h1 {
        margin: 10px 0 10px;
        font-family: Georgia, "Times New Roman", serif;
        font-size: clamp(36px, 10vw, 52px);
        line-height: 1;
        letter-spacing: -0.05em;
    }

    > p { margin: 0 0 26px; color: var(--text-soft); }
`;

const Benefits = styled.div`
    display: grid;
    gap: 10px;
    margin-bottom: 26px;

    div {
        padding: 14px 16px;
        border-left: 3px solid var(--accent);
        background: rgba(244, 105, 159, 0.06);
    }

    h2 { margin: 0 0 3px; font-size: 15px; }
    p { margin: 0; color: var(--muted); font-size: 13px; }
`;

const Steps = styled.section`
    padding: 20px;
    border: 1px solid var(--line-strong);
    border-radius: var(--radius-lg);
    background: rgba(17, 27, 43, 0.8);

    h2 { margin: 0 0 18px; font-size: 20px; }
    ol { margin: 0; padding: 0; list-style: none; counter-reset: verification; }
    li {
        min-height: 58px;
        padding: 0 0 18px 44px;
        position: relative;
        color: var(--text-soft);
        counter-increment: verification;
    }
    li:last-child { padding-bottom: 0; }
    li::before {
        content: counter(verification);
        position: absolute;
        top: -2px;
        left: 0;
        width: 30px;
        height: 30px;
        display: grid;
        place-items: center;
        border: 1px solid var(--accent);
        border-radius: 50%;
        color: var(--accent-strong);
        font-size: 13px;
        font-weight: 800;
    }
`;

const FooterNote = styled.p`
    margin: 18px 0 0 !important;
    color: var(--muted) !important;
    font-size: 13px;
`;

const VerifyPage = () => {
    document.title = `Verify${ DATA.websiteTitle }`;

    return (
        <Page>
            <Link className="back-link" to="/">← Back to search</Link>
            <h1>Verify your gender</h1>
            <p>Verification adds a trusted badge to your profile and unlocks verified-only matching.</p>

            <Benefits>
                <div>
                    <h2>Build trust</h2>
                    <p>Let other people know they are connecting with a verified woman.</p>
                </div>
                <div>
                    <h2>Unlock matching controls</h2>
                    <p>Verified users can filter searches to show verified profiles only.</p>
                </div>
            </Benefits>

            <Steps>
                <h2>Three simple steps</h2>
                <ol>
                    <li>Take a clear selfie while holding a piece of paper with your Telegram username.</li>
                    <li>Make sure your face and the username on the paper are easy to read.</li>
                    <li>Send the photo to <a href="https://t.me/achi_tov_levad" target="_blank" rel="noreferrer">@achi_tov_levad</a> on Telegram.</li>
                </ol>
            </Steps>
            <FooterNote>Verification is free. Photos are reviewed within 24 hours.</FooterNote>
        </Page>
    );
};

export default VerifyPage;
